import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 6E585638-20B9-4347-B991-62027390FCE4
 * name sticker-alert
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sticker-alert.svg
 * tags
 * - Alert / Error 
 */
export const StickerAlertIcon = createSvgIcon(<><path d="M18.5 2H5.5C3.6 2 2 3.6 2 5.5V18.5C2 20.4 3.6 22 5.5 22H16L22 16V5.5C22 3.6 20.4 2 18.5 2M13 17H11V15H13V16M13 13H11V7H13V12M15 20V18.5C15 16.6 16.6 15 18.5 15H20L15 20Z" /></>, 'StickerAlertIcon');
export default StickerAlertIcon